import { render, staticRenderFns } from "./PdfProductTable.vue?vue&type=template&id=be657bc2&scoped=true&"
import script from "./PdfProductTable.vue?vue&type=script&lang=js&"
export * from "./PdfProductTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfProductTable.vue?vue&type=style&index=0&id=be657bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be657bc2",
  null
  
)

export default component.exports